import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { M as O, D as L, T as S, Qo as g, bo as o, w as $, di as A } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as v } from "./state-b4c9cc73-ee633f6c.js";
import { i as N } from "./query-24926cff-3eb94bfb.js";
import { E as T } from "./keys-b2183e45-74d07070.js";
import { l as k } from "./orientations-42163445-a7edd586.js";
import { r as D, i as I, y as x, s as P } from "./lifecycle-decorators-ecc4e836-92da4b80.js";
import { A as z } from "./query-assigned-ba663908-228b08f4.js";
import { r as b } from "./utils-2e24a437-383bbd0f.js";
var f = /* @__PURE__ */function (t) {
    return t.CLICK = "click", t.HOVER = "hover", t.MANUAL = "manual", t;
  }(f || {}),
  c = /* @__PURE__ */function (t) {
    return t.START = "start", t.CENTER = "center", t.END = "end", t;
  }(c || {}),
  B = /* @__PURE__ */function (t) {
    return t.HORIZONTAL = "horizontal", t.VERTICAL = "vertical", t;
  }(B || {}),
  n = /* @__PURE__ */function (t) {
    return t.BlockStart = "block-start", t.InlineStart = "inline-start", t.BlockEnd = "block-end", t.InlineEnd = "inline-end", t;
  }(n || {});
function j(t, l) {
  return t.has(l) && typeof t.get(l) < "u";
}
var W = Object.defineProperty,
  K = Object.getOwnPropertyDescriptor,
  s = function s(t, l, i, h) {
    for (var a = h > 1 ? void 0 : h ? K(l, i) : l, e = t.length - 1, r; e >= 0; e--) (r = t[e]) && (a = (h ? r(l, i, a) : r(a)) || a);
    return h && a && W(l, i, a), a;
  };
var F = function F(t) {
  return function (l) {
    var i = /*#__PURE__*/function (_l) {
      _inherits(i, _l);
      function i() {
        var _thisSuper, _this;
        _classCallCheck(this, i);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.orientation = k.VERTICAL, _this.trigger = f.HOVER, _this.isOpen = !1, _this.content = "", _this.alignment = c.CENTER, _this.direction = n.InlineStart, _this.topOffset = 0, _this.leftOffset = 0, _this.RTL = !1, _this.marginAdjust = 0, _this.targetSelectorString = ".overlay-target", _this.debouncedCalculateOffset = b(_this.calculateOffset.bind(_assertThisInitialized(_assertThisInitialized(_this))), 100), _this.toggleClick = function () {
          _this.isOpen ? _this.close() : _this.open();
        }, _this.intersectionObserver = new IntersectionObserver(_this.debouncedCalculateOffset, {
          threshold: 1
        }), _this.resizeObserver = new ResizeObserver(_this.debouncedCalculateOffset), _this.open = t && !t.disableDebounceOpen ? b(function () {
          _this.calculateOffset(), _this.isOpen = !0, _this.emitOpen();
        }, 100) : function () {
          _this.calculateOffset(), _this.isOpen = !0, _this.emitOpen();
        }, _this.handleKeydown = function (e) {
          e.isTrusted && _this.isOpen && (_get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(i.prototype)), "handleKeydown", _thisSuper).call(_thisSuper), _this.closeOnEscape(e));
        }, _this.handleExternalClick = function (e) {
          _this.isOpen && _this.isOutsideOverlay(e.target) && _this.close();
        };
        return _this;
      }
      _createClass(i, [{
        key: "computeMarginAdjustment",
        /**
         * Calculates margin adjustment for when the overlay component is visible
         * @param marginToken token representing the margin of the overlay component
         * @param arrowSizeToken token representing the size of the arrow on the overlay
         */
        value: function computeMarginAdjustment(e, r) {
          this.marginAdjust = parseInt(e, 10) + parseInt(r, 10) / 2;
        }
        /**
         * Evaluate Alignment and Direction based on the Target and Overlay DOMRect.
         * @param target DOMRect of the target element
         * @param overlay DOMRect of the overlay element
         */
      }, {
        key: "computeDirection",
        value: function computeDirection(e, r) {
          this.orientation === k.VERTICAL ? (e.y < this.viewportRect.height / 4 ? this.direction = n.BlockStart : this.direction = n.BlockEnd, e.x < this.viewportRect.width / 4 ? this.alignment = c.START : e.x > this.viewportRect.width * 3 / 4 ? this.alignment = c.END : this.alignment = c.CENTER) : (this.alignment = c.CENTER, this.RTL ? this.viewportRect.width < e.x ? this.direction = n.InlineEnd : this.direction = n.InlineStart : e.x + e.width + r.width < this.viewportRect.width ? this.direction = n.InlineStart : this.direction = n.InlineEnd);
        }
        /**
         * @param overlayWidth Width of the Overlay element
         * @param targetWidth Width of the Target Element
         * @returns Based on Alignment, will return leftOffset as number.
         */
      }, {
        key: "calculateHorizontalOffset",
        value: function calculateHorizontalOffset(e, r) {
          var d = r - e,
            p = e / 2 - this.marginAdjust;
          switch (this.alignment) {
            case c.START:
              return d / 2 + p;
            case c.CENTER:
              return d / 2;
            case c.END:
              return d / 2 - p;
            default:
              return 0;
          }
        }
        /**
         * Evaluate the Overlay Leftoffset and topOffset based on targetSelector and Overlay Selector.
         * @abstract
         */
      }, {
        key: "calculateOffset",
        value: function calculateOffset() {
          var e, r, d;
          var p = (e = this.shadowRoot) == null ? void 0 : e.querySelector(this.targetSelector),
            E = (r = this.shadowRoot) == null ? void 0 : r.querySelector(this.overlaySelector);
          if (E && (p || this.targetRectObj)) {
            var w = (d = this.targetRectObj) != null ? d : p == null ? void 0 : p.getBoundingClientRect(),
              R = E.getBoundingClientRect();
            this.computeDirection(w, R);
            var y = w.height,
              m = w.width,
              u = R.height,
              C = R.width;
            switch (this.topOffset = 0, this.leftOffset = m, this.direction) {
              case n.BlockEnd:
                this.topOffset = -1 * (y + u), this.leftOffset = this.calculateHorizontalOffset(C, m);
                break;
              case n.BlockStart:
                this.leftOffset = this.calculateHorizontalOffset(C, m);
                break;
              case n.InlineEnd:
                this.leftOffset = -1 * C, this.topOffset = -1 * (u + (y - u) / 2);
                break;
              case n.InlineStart:
                this.topOffset = -1 * (u + (y - u) / 2);
                break;
            }
          }
        }
        /**
         * Enables overlay surface to reposition and reorient based on:
         * 1. When overlayWrapper is intersecting with viewport border
         * 2. When document body is resized
         * 3. When user scrolls
         */
      }, {
        key: "engageDynamicOverlayPositioning",
        value: function engageDynamicOverlayPositioning() {
          this.intersectionObserver.observe(this.overlayWrapper), this.resizeObserver.observe(document.body), this.scrollListeningContainer.addEventListener("scroll", this.debouncedCalculateOffset);
        }
        /**
         * Disengages dynamic overlay positioning by unobserving by:
         * 1. Unobserving overlayWrapper intersections with viewport
         * 2. Unobserving resize of the document body
         * 3. Removing scroll event listener from scrollListeningContainer
         */
      }, {
        key: "disengageDynamicOverlayPositioning",
        value: function disengageDynamicOverlayPositioning() {
          this.intersectionObserver.unobserve(this.overlayWrapper), this.resizeObserver.unobserve(document.body), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
        }
        /**
         * Destroys dynamic overlay positioning by:
         * 1. Disconnecting intersection observer
         * 2. Disconnecting resize observer
         * 3. Removing scroll event listener from scrollListeningContainer
         * This method is intended for use when disconnecting component.
         */
      }, {
        key: "destroyDynamicOverlayPositioning",
        value: function destroyDynamicOverlayPositioning() {
          this.intersectionObserver.disconnect(), this.resizeObserver.disconnect(), this.scrollListeningContainer.removeEventListener("scroll", this.debouncedCalculateOffset);
        }
        /**
         * Makes the overlay hidden.
         */
      }, {
        key: "close",
        value: function close() {
          this.isOpen = !1;
        } /** Closes the popover when the key pressed is the escape key. */
      }, {
        key: "closeOnEscape",
        value: function closeOnEscape(e) {
          e.key === T.ESCAPE && this.close();
        }
        /**
         * @param node target element
         * @returns whether the target element is outside of the overlay content
         */
      }, {
        key: "isOutsideOverlay",
        value: function isOutsideOverlay(e) {
          if (this.overlayWrapper.contains(e) || this.contains(e)) return !1;
          var r = e.getRootNode();
          return !(r instanceof ShadowRoot && this.contains(r.host));
        }
        /**
         * @event {BeaconEvents} beacon-events-close - emits when the overlay is closed with the close() method.
         */
      }, {
        key: "emitClose",
        value: function emitClose() {
          L(this, S.CLOSE);
        }
        /**
         * @event {BeaconEvents} beacon-events-open - emits when the overlay is closed with the open() method.
         */
      }, {
        key: "emitOpen",
        value: function emitOpen() {
          L(this, S.OPEN);
        }
        /**
         * Lit lifecycle hook to handle changing of properties
         */
      }, {
        key: "updated",
        value: function updated(e) {
          j(e, "isOpen") && (this.isOpen ? (this.open(), this.emitOpen()) : (this.close(), this.emitClose()));
        }
      }, {
        key: "overlayPrerender",
        value: function overlayPrerender() {
          this.isOpen && this.open(), this.externalClickNode.addEventListener(g.CLICK, this.handleExternalClick), this.externalClickNode.addEventListener(g.KEYDOWN, this.handleKeydown);
        }
      }, {
        key: "overlayPostrender",
        value: function overlayPostrender() {
          this.calculateOffset();
        }
      }, {
        key: "overlayDestroy",
        value: function overlayDestroy() {
          this.destroyDynamicOverlayPositioning(), this.externalClickNode.removeEventListener(g.KEYDOWN, this.handleKeydown), this.externalClickNode.removeEventListener(g.CLICK, this.handleExternalClick);
        }
        /**
         * Render template: slotted element
         */
      }, {
        key: "renderSlot",
        value: function renderSlot() {
          return this.trigger === f.HOVER ? o(_templateObject || (_templateObject = _taggedTemplateLiteral(["<slot @mouseover=", " @mouseout=", "></slot>"])), this.open, this.close) : this.trigger === f.CLICK ? o(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<slot @click=", "></slot>"])), this.toggleClick) : o(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<slot></slot>"])));
        }
        /**
         * Render template: overlay content
         */
      }, {
        key: "renderOverlayContent",
        value: function renderOverlayContent() {
          return o(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<p>", "</p>"])), this.content);
        }
        /**
         * Render template: overlay content skeleton
         */
      }, {
        key: "renderContentWrapper",
        value: function renderContentWrapper() {
          return o(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<div class=\"tooltip-content\" aria-live=\"", "\">", "</div>"])), this.isOpen ? "polite" : "off", this.renderOverlayContent());
        }
        /**
         * Render template: arrow
         * @todo align the arrow implementation with the navigation popover arrow
         */
      }, {
        key: "renderArrow",
        value: function renderArrow() {
          return o(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<span class=\"overlay-arrow ", "\" aria-hidden=\"true\"></span>"])), this.alignment);
        }
        /**
         * Render template: entire overlay skeleton
         */
      }, {
        key: "renderOverlayWrapper",
        value: function renderOverlayWrapper() {
          return this.style.setProperty("--left-offset", "".concat(this.leftOffset, "px")), this.style.setProperty("--top-offset", "".concat(this.topOffset, "px")), o(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<div\n          id=\"", "\"\n          role=\"tooltip\"\n          aria-hidden=\"", "\"\n          class=\"overlay-wrapper ", "\"\n        >\n          ", " ", "\n        </div>"])), this.overlayName, this.isOpen ? "false" : "true", this.direction, this.renderArrow(), this.renderContentWrapper());
        }
        /**
         * Render template: overlay and target
         */
      }, {
        key: "render",
        value: function render() {
          return o(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", "\n        ", ""])), this.trigger === f.MANUAL ? $ : o(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["<div class=\"overlay-target\" aria-describedBy=\"", "\">", "</div>"])), this.overlayName, this.renderSlot()), this.renderOverlayWrapper());
        }
      }, {
        key: "targetSelector",
        get: function get() {
          return this.targetSelectorString;
        },
        set: function set(e) {
          this.targetSelectorString = e;
        }
      }, {
        key: "viewportRect",
        get: function get() {
          var e;
          return (e = this.viewportRectObj) != null ? e : document.documentElement.getBoundingClientRect();
        },
        set: function set(e) {
          this.viewportRectObj = e;
        }
      }, {
        key: "targetRect",
        set: function set(e) {
          this.targetRectObj = e;
        }
      }, {
        key: "scrollListeningContainer",
        get: function get() {
          var e;
          return (e = this.scrollListeningContainerObj) != null ? e : window;
        },
        set: function set(e) {
          this.scrollListeningContainerObj = e;
        }
      }, {
        key: "overlaySelector",
        get: function get() {
          return ".overlay-wrapper";
        }
      }, {
        key: "overlayName",
        get: function get() {
          return "overlay";
        }
      }, {
        key: "externalClickNode",
        get: function get() {
          return this.getRootNode();
        }
      }], [{
        key: "overlayStyles",
        get: function get() {
          return [];
        }
      }]);
      return i;
    }(l);
    s([O()], i.prototype, "orientation", 2), s([O()], i.prototype, "trigger", 2), s([O({
      type: Boolean,
      reflect: !0,
      attribute: "is-open"
    })], i.prototype, "isOpen", 2), s([O()], i.prototype, "content", 2), s([v()], i.prototype, "alignment", 2), s([v()], i.prototype, "direction", 2), s([v()], i.prototype, "topOffset", 2), s([v()], i.prototype, "leftOffset", 2), s([v()], i.prototype, "RTL", 2), s([N(".overlay-wrapper")], i.prototype, "overlayWrapper", 2), s([D], i.prototype, "overlayPrerender", 1), s([I], i.prototype, "overlayPostrender", 1), s([x], i.prototype, "overlayDestroy", 1), i = s([P("Overlay")], i);
    var h = /*#__PURE__*/function (_i) {
      _inherits(h, _i);
      function h() {
        var _this2;
        _classCallCheck(this, h);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(h).apply(this, arguments)), _this2.open = t && !t.disableDebounceOpen ? b( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.calculateOffset();
                _this2.engageDynamicOverlayPositioning();
                _this2.activeElement = document.activeElement;
                _context.next = 5;
                return _this2.updateComplete;
              case 5:
                _this2.isOpen = !0;
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), 100) : /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this2.calculateOffset();
                _this2.engageDynamicOverlayPositioning();
                _this2.activeElement = document.activeElement;
                _context2.next = 5;
                return _this2.updateComplete;
              case 5:
                _this2.isOpen = !0;
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return _this2;
      }
      /**
       * Handle close and return focus to active element.
       * Also removes listener and observer logic when overlay closed for better performance.
       */
      _createClass(h, [{
        key: "close",
        value: function close() {
          _get(_getPrototypeOf(h.prototype), "close", this).call(this), this.disengageDynamicOverlayPositioning(), this.focusOnActiveElement();
        }
        /**
         * Handle dark mode theming in action zone
         */
      }, {
        key: "setActionZoneDarkMode",
        value: function setActionZoneDarkMode() {
          this.slottedActionzone && this.slottedActionzone.length && this.slottedActionzone.forEach(function (e) {
            e.classList.contains("beacon-on-dark") || e.classList.add("beacon-on-dark");
          });
        }
        /**
         * Focuses on the previously active element
         */
      }, {
        key: "focusOnActiveElement",
        value: function focusOnActiveElement() {
          var e;
          (e = this.activeElement) == null || e.focus();
        }
        /**
         * Render template: close icon button
         */
      }, {
        key: "renderCloseButton",
        value: function renderCloseButton() {
          return A(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["<", "\n                variant=\"tertiary\"\n                label=\"Close Button\"\n                class=\"beacon-popover-close-button beacon-on-dark\"\n                @beacon-event-click=\"", "\"\n                >\n                <svg slot=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z\"/>\n                </svg>\n                </", ">\n                "])), this.getScopedTag("beacon-icon-button"), this.close, this.getScopedTag("beacon-icon-button"));
        }
        /**
         * Render template: adjusts content wrapper
         */
      }, {
        key: "renderContentWrapper",
        value: function renderContentWrapper() {
          return o(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["<div class=\"beacon-popover-surface\">\n          ", "\n          <div class=\"beacon-popover-zones-wrapper\" aria-live=\"", "\">", "</div>\n        </div>"])), this.renderCloseButton(), this.isOpen ? "polite" : "off", this.renderOverlayContent());
        }
        /**
         * Render template: slot with only click event
         */
      }, {
        key: "renderSlot",
        value: function renderSlot() {
          return o(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["<slot @click=", "></slot>"])), this.toggleClick);
        }
      }]);
      return h;
    }(i);
    return s([v()], h.prototype, "activeElement", 2), s([z({
      flatten: !0,
      slot: "actionzone"
    })], h.prototype, "slottedActionzone", 2), t && t.interactive ? h : i;
  };
};
export { F as Q, j, c as l, n, f as v, B as z };